// Route guard: render children only for an authenticated admin; otherwise
// bounce to /login. Authentication is the in-memory access token (set on
// login or by the boot-time refresh), surfaced reactively via useAuth so a
// token change (login / logout / refresh) re-evaluates the guard.

import { Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? <>{children}</> : <Navigate to="/login" replace />;
}
